import { supabase } from '../lib/supabase';

/**
 * Phases du cas avec group === '2' (parcours production), avec jalons triés.
 * Lecture seule — aligné sur case_timeline_phases / phase_milestones.
 */
export async function fetchGroup2PhasesWithMilestones(caseId,currentPhase) {
  if (!caseId) return [];

  const { data, error } = await supabase
    .from('case_timeline_phases')
    .select(
      `
      id,
      phase_name,
      phase_order,
      status,
      milestones:phase_milestones (
        id,
  milestone_name,
  milestone_template_id,
  milestone_order,
  completion_type,
  note,
  is_completed,
  completed_date,
  is_rejected,
  rejected_date,
  description
      )
    `
    )
    .eq('case_id', caseId)
    .eq('group', currentPhase)
    .order('phase_order', { ascending: true });

  if (error) {
    console.error('[productionCaseGroup2Service]', error);
    return [];
  }

  return (data || []).map((phase) => ({
    ...phase,
    milestones: [...(phase.milestones || [])].sort(
      (a, b) => (a.milestone_order ?? 0) - (b.milestone_order ?? 0)
    ),
  }));
}
